import { BodyText, FlexColumn, FlexRow, SvgIcon } from '@make-software/cspr-design';
import InfoIcon from 'assets/icons/ic-info.svg';
import React from 'react';
import styled from 'styled-components';

const StyledInfoWrapper = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    width: ['45%', '65%', '100%'],
    borderRadius: '4px',
    backgroundColor: theme.styleguideColors.fillSecondary
  })
);

const StyledSvg = styled(SvgIcon)(({ theme }) =>
  theme.withMedia({
    path: {
      fill: theme.styleguideColors.contentLightBlue
    }
  })
);

const InfoRowText = styled(BodyText)(({ theme }) =>
  theme.withMedia({
    color: theme.styleguideColors.contentSecondary
  })
);

interface InfoSectionProps {
  title: string;
  content: React.ReactNode;
}

export const InfoSection: React.FC<InfoSectionProps> = ({ title, content }) => {
  return (
    <StyledInfoWrapper gap={10}>
      <FlexRow gap={8} align={'center'} style={{ marginLeft: '16px', marginTop: '16px' }}>
        <StyledSvg src={InfoIcon} size={16} />
        <BodyText size={1} scale={'xs'}>
          {title}
        </BodyText>
      </FlexRow>
      <FlexRow style={{ marginLeft: '16px', marginBottom: '16px' }}>
        <InfoRowText size={3} scale={'xs'}>
          {content}
        </InfoRowText>
      </FlexRow>
    </StyledInfoWrapper>
  );
};
